import { Component, Vue } from 'vue-property-decorator'
import 'reflect-metadata';
import '@/plugins/index'
import '@/bootstrap/global/filters'
import '@/bootstrap/global/mixins'
import '@/bootstrap/global/naviagator'
import '@/bootstrap/validation/rules'
import '@/bootstrap/global/prototypes'
import '@/bootstrap/global/loader-component'
import { mapState } from 'vuex'
import GtrEndUserLayout from '@/modules/common/views/layouts/enduser.layout.vue'
import SecurityContext from '@/modules/common/services/security-context.service'
import GtrStorage from '@/modules/common/services/storage.service'
import Container from 'typedi'
import ErrorHandlerService from '@/modules/common/services/error-handler.service'

@Component({
	name: 'GtrPortalApplication',
	computed: mapState('common', ['loader']),
	components: {
		'enduser-layout': GtrEndUserLayout
	}
})
export default class GtrPortalApplication extends Vue {
	refreshTokenInterval = 600000 // 10 minutes

	mounted () {
		setTimeout(this.refreshToken, 5000) // Initial refresh after 5 seconds
		setInterval(this.refreshToken, this.refreshTokenInterval)
	}

	async refreshToken () {
		const securityContext = JSON.parse(Container.get(GtrStorage).getItem('user_session'))
		if (securityContext?.expires_at > (new Date).toISOString()) {
			try {
				await this.$store.dispatch('auth/refreshToken', { event_identifier: this.$route.params.course_uuid, form: '' })
			} catch (err) {
				Container.get(ErrorHandlerService).error(err)
			}
		}
	}

	get layout() {
		if (this.$route.meta && this.$route.meta.layout) {
			return `${this.$route.meta.layout}-layout`
		}
		return 'div'
	}
	//#endregion
}
